import { render, staticRenderFns } from "./ProductSet.vue?vue&type=template&id=a48d15ca&lang=pug&"
import script from "./ProductSet.vue?vue&type=script&lang=js&"
export * from "./ProductSet.vue?vue&type=script&lang=js&"
import style0 from "./ProductSet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a48d15ca')) {
      api.createRecord('a48d15ca', component.options)
    } else {
      api.reload('a48d15ca', component.options)
    }
    module.hot.accept("./ProductSet.vue?vue&type=template&id=a48d15ca&lang=pug&", function () {
      api.rerender('a48d15ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/ProductSet.vue"
export default component.exports